<app-modal-header-common [dialogRef]="dialogRef"></app-modal-header-common>
<div class="p-4">
  <div class="header-inline" [hidden]="injectedData?.purpose === 'download'">
    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
    <h5>Are You Sure?</h5>
  </div>
  <h5 [hidden]="!(injectedData?.purpose === 'download')">
    Do you want to download the file?
  </h5>
  <mat-dialog-content>
    <p>{{ message }}</p>
  </mat-dialog-content>
</div>
<div class="modal-footer border-0" style="padding-top: 0px">
  <div class="row">
    <div class="col-md-6">
      <button mat-raised-button mat-dialog-close tabindex="-1">
        {{ cancelButtonText }}
      </button>
    </div>
    <div class="col-md-6">
      <button
        mat-raised-button
        color="primary"
        (click)="onConfirmClick()"
        tabindex="1"
      >
        {{ confirmButtonText }}
      </button>
    </div>
  </div>
</div>

